var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{attrs:{"exact":!_vm.isHomePage,"link":"","to":_vm.item.link,"active-class":'menu-item-active'}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-"+_vm._s(_vm.item.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }